<template>
  <div class="w-64 bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 flex flex-col h-full">
    <!-- Header -->
    <div class="px-3 py-2.5 border-b border-gray-200 dark:border-gray-700">
      <h3 class="text-sm font-semibold text-gray-900 dark:text-white">Ücretli Yollar</h3>
    </div>

    <!-- Active Toll Roads -->
    <div class="flex-1 overflow-hidden flex flex-col">
      <div class="p-3">
        <h4 class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">Aktif</h4>
        <div class="space-y-1.5 max-h-64 overflow-y-auto">
          <div
            v-for="(item, index) in pricingRoadList"
            :key="index"
            @click="addAvoidPoint(item)"
            class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 rounded p-2 cursor-pointer transition-colors"
          >
            <div class="flex items-center justify-between">
              <p class="text-xs text-gray-900 dark:text-white font-medium flex-1 pr-2 line-clamp-2">
                {{ item.name }}
              </p>
              <div class="flex items-center space-x-1.5 flex-shrink-0">
                <span
                  v-if="item.price && item.price > 0"
                  class="text-xs font-semibold text-green-600 dark:text-green-400"
                >
                  {{ Money(item.price) }}₺
                </span>
                <span
                  v-else
                  class="text-xs px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded"
                >
                  Özel
                </span>
                <i class="fas fa-minus-circle text-red-500 text-xs"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Avoided Toll Roads -->
      <div v-if="avoidList.length > 0" class="p-3 border-t border-gray-200 dark:border-gray-700">
        <h4 class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">Yasaklanan</h4>
        <div class="space-y-1.5 max-h-32 overflow-y-auto">
          <div
            v-for="(item, index) in avoidList"
            :key="index"
            @click="removeAvoidList(item)"
            class="bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 rounded p-2 cursor-pointer transition-colors"
          >
            <div class="flex items-center justify-between">
              <p class="text-xs text-red-900 dark:text-red-100 font-medium flex-1 pr-2 line-clamp-2">
                {{ getDisplayName(item) }}
              </p>
              <div class="flex items-center space-x-1.5 flex-shrink-0">
                <span
                  v-if="item.price && item.price > 0"
                  class="text-xs font-semibold text-red-600 dark:text-red-400"
                >
                  {{ Money(item.price) }}₺
                </span>
                <span
                  v-else-if="isRestrictedArea(item)"
                  class="text-xs px-1.5 py-0.5 bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 rounded"
                >
                  <i class="fas fa-draw-polygon"></i>
                </span>
                <i class="fas fa-times text-red-500 text-xs"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TollRoadsSidebar',
  props: {
    pricingRoadList: {
      type: Array,
      default: () => []
    },
    avoidList: {
      type: Array,
      default: () => []
    },
    rectangles: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    Money(value) {
      return Number(value).toFixed(2);
    },
    getDisplayName(item) {
      // Check if it's a restricted area
      if (item.id && (item.id === 'custom' || item.id.toString().startsWith('restricted-'))) {
        // Find index in rectangles array
        const index = this.rectangles.findIndex(r => r.id === item.id);
        if (index !== -1) {
          return `Yasaklı Alan ${index + 1}`;
        }
        return 'Yasaklı Alan';
      }
      return item.name || 'Özel Alan';
    },
    isRestrictedArea(item) {
      return item.id && (item.id === 'custom' || item.id.toString().startsWith('restricted-'));
    },
    addAvoidPoint(item) {
      this.$emit('add-avoid-point', item);
    },
    removeAvoidList(item) {
      // If it's a restricted area, emit special event to remove rectangle
      if (this.isRestrictedArea(item)) {
        this.$emit('remove-rectangle', item.id);
      } else {
        this.$emit('remove-avoid-list', item);
      }
    }
  }
}
</script>

<style scoped>
/* Custom scrollbar for better UX */
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: transparent;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: rgba(156, 163, 175, 0.5);
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background-color: rgba(156, 163, 175, 0.7);
}
</style>